<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">

    <!-- This is hidden from user, it is used to get the current grid size -->
    <span id="theSize" style="font-size: 0;">
      <span class="d-none d-xl-block">XL</span>
      <span class="d-none d-lg-block d-xl-none">LG</span>
      <span class="d-none d-md-block d-lg-none d-xl-none">MD</span>
      <span class="d-none d-sm-block d-md-none d-lg-none d-xl-none">SM</span>
      <span class="d-block d-sm-none d-md-none d-lg-none d-xl-none">D</span>
    </span>
    <!-- End of what is hidden from user -->

    <b-col>
      <div class="center-form">
        <h2 class="text-center">Create a race</h2>
        <br>
        <b-form class="">
          <b-form-group id="type" label-for="type">
            <h4>Type</h4>
            <b-form-radio v-model="form.type.value" value="normal">Normal Bike</b-form-radio>
            <b-form-radio v-model="form.type.value" value="ebike">E-Bike</b-form-radio>
            <b-form-invalid-feedback :state="form.type.error.state">
              {{ form.type.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group id="name" label-for="name">
            <h4>Race name</h4>
            <b-form-input 
              id="name"
              v-model="form.name.value" 
              :state="form.name.error.state"
              placeholder="name"
              required
            />
            <b-form-invalid-feedback :state="form.name.error.state">
              {{ form.name.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group id="recommendedRouteId" label-for="recommendedRouteId">
            <div class="inline">
              <fa-icon icon="question-circle" v-tooltip:right="`The route has to show the path riders will take to perform the race. It should include all stages and transfers, with a start and finish line close to each other. You should first create it on Strava, and then press the button to pull it here.`" />
              &nbsp;
              <h4 class="inline">Recommended route</h4>
              <br>
              <span>(Create one <a href="https://www.strava.com/routes/new" target="_blank">here</a>. More info <a href="https://support.strava.com/hc/en-us/articles/216918387-Routes-on-Web" target="_blank">here</a>)</span>
            </div>
            &nbsp;<c-button :onClick="updateStravaRoutes" variant="primary" size="sm"><span class="smaller-font-2">Pull routes from Strava</span></c-button>
            <div 
              v-if="stravaRoutes.length > 0"
              class="wide-form-section" 
            >
              <b-row :cols="routesPagination.definition.d" :cols-sm="routesPagination.definition.sm" :cols-md="routesPagination.definition.md" :cols-lg="routesPagination.definition.lg" :cols-xl="routesPagination.definition.xl">
                <b-col 
                  v-for="route in stravaRoutes"
                  :key="route.stravaRouteId"
                  class="margin-top-bottom"
                >
                  <b-card :img-src="route.stravaDetails.map_urls.url" :img-alt="route.stravaDetails.name" img-top>
                    <b-card-text>
                      <h5 class="inline">{{ route.stravaDetails.name }}</h5>
                      <br>
                      <br>
                      <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
                        <b-col>
                          <b>Distance:</b> {{ route.stravaDetails.distance | metersToKilometers }} km
                          <br><br>
                          <b>Elevation:</b> {{ route.stravaDetails.elevation_gain | meters }} m
                        </b-col>
                        <b-col>
                          <b>Created on:</b> {{ route.stravaDetails.created_at | date }}
                        </b-col>
                      </b-row>
                      <br>
                      <div class="center-align">
                        <span v-if="form.recommendedRouteId.value === route.stravaRouteId" class="text-yellow">Selected</span>
                        <span v-else><a @click.prevent="selectRecommendedRoute(route.stravaRouteId)" class="text-blue">Select</a></span>
                      </div>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <br>
              No route has been found. Please first create a route on Strava and click on the above button "Pull routes from Strava"
            </div>
            <div class="center-align">
              <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'loadStravaRoutes', 'routesPagination')"/>
                Page: {{ routesPagination.page }} / {{ routesPagination.totalPages }}
              <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'loadStravaRoutes', 'routesPagination')"/>
            </div>
            <b-form-invalid-feedback :state="form.recommendedRouteId.error.state">
              {{ form.recommendedRouteId.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>
          <br>
          <div class="inline">
            <fa-icon icon="question-circle" v-tooltip:right="`The itineary is the detail of all the stages and transfers' time. The stages are Strava segments. The segments have to be starred on Strava. You should first star the segments on Strava, and then press the button to pull them here.`" />
            &nbsp;
            <h4 class="inline">Itineary</h4>
          </div>
          <br>
          <span>A race starts with a stage and ends with a stage. The initial transfer to the 1st stage as well as the ending transfer after the last stage don't count.</span>
          <b-form-group id="steps" label-for="steps">
          <br>
          <table class="full-width">
            <thead>
            <tr>
              <th>Step</th>
              <th>Value</th>
              <th v-if="form.steps.value.length > 3">Delete</th>
            </tr>
            </thead>
            <tbody>
            <tr 
              v-for="(step, index) in form.steps.value"
              :key="step.order"
            >
                <td>
                  <span>{{ step.type }} {{ step.number }}</span>
                </td>
                <td>
                  <b-form-input 
                    v-if="step.type === 'Transfer'"
                    v-model="step.value" 
                    placeholder="Time in minutes"
                    style="width: 150px"
                  />
                  <span v-else>
                    <div v-if="form.steps.value[index].value">
                      <b>{{ form.steps.value[index].name }}</b>
                      &nbsp;
                      <a @click.prevent="viewStarredSegments(index)" class="text-blue">Change</a>
                    </div>
                    <div v-else>
                      <a @click.prevent="viewStarredSegments(index)" class="text-blue">Select</a>
                    </div>
                  </span>
                </td>
                <td v-if="(index === form.steps.value.length - 1) && form.steps.value.length > 3">
                  <fa-icon 
                    icon="times"
                    class="fa-2x clickable"
                    @click="deleteConfig(form.steps.value, index)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <br>
          <fa-icon 
            icon="plus"
            class="fa-2x clickable"
            @click="addConfig(form.steps.value)"
          />
            <b-form-invalid-feedback :state="form.steps.error.state">
              {{ form.steps.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>
          <br><br><br>
          <c-button :onClick="onCancel" variant="secondary">Cancel</c-button>
          <c-button :onClick="onNext" variant="primary" class="right-align">Next</c-button>
          <br>
          <span class="success right-align">{{ formSuccess }}</span>
          <span class="failure right-align">{{ formFailure }}</span>
        </b-form>
      </div>
    </b-col>

    <b-modal ref="starredSegments" size="xl" title="Starred segments" hide-footer>
      <div class="d-block">
        <c-button :onClick="updateStravaStarredSegments" variant="primary" size="sm"><span class="smaller-font-2">Pull starred segments from Strava</span></c-button>
        <br><br>
        <span><b>WARNING:</b> You have chosen <b>{{ form.type.value === 'ebike' ? 'E-Bike' : 'Normal Bike' }}</b>. Only starred segments matching this type are displayed.</span>
        <br><br>
        <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
          <b-col>
            <span class="failure">{{ starredSegmentsFailureMessage }}</span>
              <b-table :fields="fields" :items="stravaStarredSegments" responsive="sm">
                <template #cell(name)="data">
                  <b>{{ data.item.stravaDetails.name }}</b>
                  &nbsp;
                  <a :href="`https://www.strava.com/segments/${data.item.stravaSegmentId}`" target="_blank" class="strava smaller-font">
                    View on Strava
                  </a>
                </template>

                  <template #cell(distance)="data">
                    {{ data.item.stravaDetails.distance | meters }} m
                  </template>

                  <template #cell(elevation)="data">
                    -{{ data.item.stravaDetails.elevation_high - data.item.stravaDetails.elevation_low | meters }} m
                  </template>

                  <template #cell(average_grade)="data">
                    {{ data.item.stravaDetails.average_grade }} %
                  </template>

                  <template #cell(pr_time)="data">
                    <span v-if="data.item.stravaDetails.pr_time">{{ data.item.stravaDetails.pr_time | secondsToMinutes }}</span>
                  </template>

                  <template #cell(city)="data">
                    {{ data.item.stravaDetails.city || data.item.stravaDetails.state || data.item.stravaDetails.country }}
                  </template>

                  <template #cell(starred_date)="data">
                    {{ data.item.stravaDetails.starred_date | date }}
                  </template>

                  <template #cell(select)="data">
                    <a @click.prevent="selectSegment(data.item.stravaSegmentId, data.item.stravaDetails.name)" class="text-blue">Select</a>
                  </template>
                </b-table>
                <div class="center-align">
                  <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'loadStravaStarredSegments', 'starredSegmentsPagination')"/>
                  Page: {{ starredSegmentsPagination.page }} / {{ starredSegmentsPagination.totalPages }}
                  <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'loadStravaStarredSegments', 'starredSegmentsPagination')"/>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-modal>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import { PaginationModule } from '../utils.js'

  export default {
    name: 'CreateRace',
    components: { CButton },
    props: {

    },
    data() {
      return {
        form: {
          type: {
            value: 'normal',
            error: {}
          },
          name: {
            value: '',
            error: {}
          },
          recommendedRouteId: {
            value: '',
            error: {}
          },
          steps: {
            value: [
              {
                type: 'Stage',
                number: 1,
                order: 1,
                value: '',
                name: ''
              },
              {
                type: 'Transfer',
                number: 1,
                order: 2,
                value: ''
              },
              {
                type: 'Stage',
                number: 2,
                order: 3,
                value: '',
                name: ''
              },
            ],
            error: {}
          },
        },
        stravaRoutes: [],
        stravaStarredSegments: [],
        selectedStepInSteps: null,
        formSuccess: '',
        formFailure: '',
        starredSegmentsFailureMessage: '',
        routesPagination: {
          page: 1,
          itemsPerPage: null,
          count: null,
          totalPages: null,
          definition: {
            xl: 4,
            lg: 4,
            md: 2,
            sm: 2,
            d: 1
          }
        },
        starredSegmentsPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null,
        },
        fields: [
          {
            key: 'name'
          },
          {
            key: 'distance'
          },
          {
            key: 'elevation'
          },
          {
            key: 'average_grade',
            label: 'Average grade'
          },
          {
            key: 'pr_time',
            label: 'PR'
          },
          {
            key: 'city',
          },
          {
            key: 'starred_date',
            label: 'Starred date'
          },
          {
            key: 'select'
          },
        ],
      }
    },
    async created() {
      if (this.$router.currentRoute.meta.requiresAuth && (!this.$store.state.loggedUser || !this.$store.state.loggedUser.email)) this.$router.push({name: 'SignUp'})
    },
    async mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
      })

      await this.onResize()
    },

    beforeDestroy() { 
      window.removeEventListener('resize', this.onResize); 
    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    watch: {
      'form.type.value': {
        handler: function (newVal, oldVal) {
          if (newVal !== oldVal) {
            this.$set(this.form, 'steps', {
              value: [
                {
                  type: 'Stage',
                  number: 1,
                  order: 1,
                  value: '',
                  name: ''
                },
                {
                  type: 'Transfer',
                  number: 1,
                  order: 2,
                  value: ''
                },
                {
                  type: 'Stage',
                  number: 2,
                  order: 3,
                  value: '',
                  name: ''
                },
              ],
              error: {}
            })
          }
        }
      }
    },
    methods: {
      addConfig(steps) {
        steps.push({
          type: 'Transfer',
          number: steps[steps.length-1].number,
          order: steps[steps.length-1].order + 1,
          value: ''
        })
        steps.push({
          type: 'Stage',
          number: steps[steps.length-1].number + 1,
          order: steps[steps.length-1].order + 2,
          value: '',
          name: ''
        })
      },
      deleteConfig(steps, index) {
        steps.splice(index-1, 2)
      },
      showModal(name) {
        if (Array.isArray(this.$refs[name])) {
          this.$refs[name][0].show()
        } else {
          this.$refs[name].show()
        }
      },
      hideModal(name) {
        if (Array.isArray(this.$refs[name])) {
          this.$refs[name][0].hide()
        } else {
          this.$refs[name].hide()
        }
      },
      async viewStarredSegments(index) {
        this.selectedStepInSteps = index
        await this.loadStravaStarredSegments()

        this.showModal('starredSegments');
      },
      onCancel(event) {
        this.$router.push({ name: 'Home' });
      },
      async onNext() {
        for (let key in this.form) {
          this.form[key].error = {}
        }
        this.formSuccess = ''
        this.formFailure = ''

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/createRace.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            type: this.form.type.value,
            name: this.form.name.value,
            recommendedRouteId: this.form.recommendedRouteId.value,
            steps: this.form.steps.value,
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
            if (e.body.details) {
              e.body.details.map(detail => {
                detail.path.map(path => {
                  this.$set(this.form[path], 'error', {state: false, value: detail.message})
                })
              })
            }
          }
        } else {
          this.formSuccess = "Race successfully created";
          this.$router.push({ name: 'Race', params: { id: result.data.createRace.id }});
        }
      },
      async loadStravaRoutes() {
        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/listStravaRoutes.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            page: this.routesPagination.page,
            itemsPerPage: this.routesPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
          }
        } else {
          if (result && result.data && result.data.listStravaRoutes && result.data.listStravaRoutes.routes) {
            this.stravaRoutes = [...result.data.listStravaRoutes.routes]
            this.routesPagination.count = result.data.listStravaRoutes.pagination.count
            this.routesPagination.totalPages = result.data.listStravaRoutes.pagination.totalPages
          }
        }
      },
      async updateStravaRoutes() {
        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/updateStravaRoutes.graphql'),
          fetchPolicy: 'no-cache'
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
          }
        } else {
          if (result && result.data && result.data.updateStravaRoutes && result.data.updateStravaRoutes.result) {
            await this.loadStravaRoutes()
          }
        }
      },
      async loadStravaStarredSegments() {
        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/listStravaStarredSegments.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            type: this.form.type.value,
            page: this.starredSegmentsPagination.page,
            itemsPerPage: this.starredSegmentsPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
          }
        } else {
          if (result && result.data && result.data.listStravaStarredSegments && result.data.listStravaStarredSegments.starredSegments) {
            this.stravaStarredSegments = [...result.data.listStravaStarredSegments.starredSegments]
            this.starredSegmentsPagination.count = result.data.listStravaStarredSegments.pagination.count
            this.starredSegmentsPagination.totalPages = result.data.listStravaStarredSegments.pagination.totalPages
          }
        }
      },
      async updateStravaStarredSegments() {
        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/updateStravaStarredSegments.graphql'),
          fetchPolicy: 'no-cache'
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
          }
        } else {
          if (result && result.data && result.data.updateStravaStarredSegments && result.data.updateStravaStarredSegments.result) {
            await this.loadStravaStarredSegments()
          }
        }
      },
      selectRecommendedRoute(stravaRouteId) {
        this.form.recommendedRouteId.value = stravaRouteId
      },
      selectSegment(stravaSegmentId, name) {
        this.hideModal('starredSegments')
        this.form.steps.value[this.selectedStepInSteps].value = stravaSegmentId
        this.form.steps.value[this.selectedStepInSteps].name = name
        this.selectedStepInSteps = null
      },
      pagination(type, funcToExecute, obj) {
        const paginationModule = PaginationModule();
        const newPage = paginationModule.changePage(type, this[obj].page, this[obj].totalPages);
        if (newPage) {
          this[obj].page = newPage;
          this[funcToExecute](this[obj].payload);
        }
      },
      async onResize() {
        if (document.getElementById('theSize').innerText == 'XL') {
          this.routesPagination.itemsPerPage = this.routesPagination.definition.xl
        } else if (document.getElementById('theSize').innerText == 'LG') {
          this.routesPagination.itemsPerPage = this.routesPagination.definition.lg
        } else if (document.getElementById('theSize').innerText == 'MD') {
          this.routesPagination.itemsPerPage = this.routesPagination.definition.md
        } else if (document.getElementById('theSize').innerText == 'SM') {
          this.routesPagination.itemsPerPage = this.routesPagination.definition.sm
        } else if (document.getElementById('theSize').innerText == 'D') {
          this.routesPagination.itemsPerPage = this.routesPagination.definition.d
        } else {
          this.routesPagination.itemsPerPage = this.routesPagination.definition.d
        }

        await this.loadStravaRoutes()
      }
    }
  }
</script>

<style scoped>

</style>
